import { useEffect, useState } from 'react';
import { getLatestAppVersion } from '../../../../db/news-section-db';
import styles from './styles.module.css';
import modalState from '../../../../state-observables/modal/ModalState';

/* Modal explaining what the Danger indicator means, and what actions the user can take to resolve the issue */
export default function DangerModal() {
    const [latestAppVersion, setLatestAppVersion] = useState<string | null>(null);

    useEffect(() => {
        const asyncFunc = async () => {
            getLatestAppVersion().then((latestAppVersion) => setLatestAppVersion(latestAppVersion)).catch(() => setLatestAppVersion(null));
        }
        asyncFunc();
    }, []);

    const onClose = () => {
        modalState.setModal(null, '');
    };

    return (
        <div className={styles.updateNotification}>
            <h2>Hey there, an exciting update is waiting for you!</h2>
            <br />
            <p>
                We've made some improvements and added cool new features.
                Please update your application to the latest version (v{latestAppVersion}) to enhance your experience.
                Visit the Play Store or the
                App Store, depending on
                whether you are on an Android or iOS device. Look for <strong>Marty the Robot V2</strong> app and hit update!
            </p>
            <br />
            <p>
                Need help? Check out our guide: <a href="https://userguides.robotical.io/martyv2/userguides/app#tablet_app" target="_blank" rel="noreferrer">User Guide</a>.
            </p>
            <div className={styles.closeModalButtonContainer}>
                <button className={styles.closeModalButton} onClick={onClose}>Got it</button>
            </div>
        </div>
    );
}

